import { Page } from './page';
import { Sort } from './sort';

export class SortData<T> {
    sorts = new Array<Sort>();
    pages = new Array<Page>();
    filter :T | undefined;
}
